var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminApiAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4 21.62V23H4.6V21.62H18.4ZM21.62 18.4V4.6C21.62 2.82164 20.1784 1.38 18.4 1.38H4.6C2.82164 1.38 1.38 2.82164 1.38 4.6V18.4C1.38 20.1784 2.82164 21.62 4.6 21.62V23L4.36371 22.9937C2.01129 22.8747 0.125326 20.9887 0.00628906 18.6363L0 18.4V4.6C0 2.05949 2.05949 3.70447e-08 4.6 0H18.4C20.9405 0 23 2.05949 23 4.6V18.4C23 20.8613 21.067 22.8707 18.6363 22.9937L18.4 23V21.62C20.1784 21.62 21.62 20.1784 21.62 18.4Z",
    fill: "var(--fill-0, #009BE5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.56 10.6894V12.9494H6.44V10.6894H16.56ZM12.6864 6.44V17.48H10.3237V6.44H12.6864Z",
    fill: "var(--fill-0, #009BE5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminApiAddIcon);
export default __webpack_public_path__ + "static/media/AdminApiAddIcon.5768fc1bd5a8f309717fd00b77a710f8.svg";
export { ForwardRef as ReactComponent };